import type { CSSProperties } from 'react';

/**
 * Skeleton-плейсхолдер загрузки (D5b, shimmer).
 *
 * По решению Артёма 2026-05-24 (design round 2, п.6): default loading
 * state = skeleton, НЕ blocking spinner. Spinner допустим только как
 * inline-состояние кнопки (Button loading).
 */
export interface SkeletonProps {
  /** Ширина блока (CSS-значение), по умолчанию 100%. */
  width?: string | number;
  /** Высота блока (CSS-значение), по умолчанию 16px. */
  height?: string | number;
  /** Радиус скругления (CSS-значение), по умолчанию 8px. */
  radius?: string | number;
  className?: string;
  'data-testid'?: string;
}

export function Skeleton({
  width = '100%',
  height = 16,
  radius = 8,
  className,
  'data-testid': testId,
}: SkeletonProps): JSX.Element {
  const style: CSSProperties = { width, height, borderRadius: radius };
  return (
    <span
      aria-hidden="true"
      className={['hsc-skeleton', className].filter(Boolean).join(' ')}
      style={style}
      data-testid={testId}
    />
  );
}
